<!--
@Time : 2020/12/1 4:21 下午
@Author : yekong
@File : 3dzhu.vue
@Software : PhpStorm
-->
<template>
  <div class="zzt2">
    <!--    <div :id="id" :option="option"></div>-->
    <div ref="cha" class="zzt"></div>
  </div>
</template>

<script>

export default {
  name: "3dzhu",
  data: function () {
    return {}
  },
  props: {
    id: {
      type: String
    },
    //option 是图表的配置数据
    option: {
      type: Object
    }
  },
  mounted() {
    // HighCharts.chart(this.id, this.option)
    this.drawLine();

  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      var xData = ["北京", "上海", "深圳", "大连"];
      var yData = [96, 80, 80, 80];
      var barTopColor = ["rgba(137, 44, 206, 1)", "rgba(9, 91, 205, 1)", "rgba(227, 108, 61, 1)", 'rgba(61, 135, 227, 1)'];
      var barBottomColor = ["rgba(143, 84, 227, 1)", "rgba(63, 105, 227, 1)", "rgba(220, 147, 104, 1)", 'rgba(48, 193, 224, 1)'];

      var that = this;
      let myChart = this.$echarts.init(this.$refs.cha)
      // let myChart = this.$echarts.init(document.getElementById('huodexindai1'))
      // 绘制图表
      myChart.setOption({
        "grid": {
          "top": "25%",
          "left": "0%",
          "bottom": "5%",
          "right": "5%",
          "containLabel": true
        },
        tooltip: {
          show: true
        },
        animation: false,
        "xAxis": [{
          "type": "category",
          "data": xData,
          "axisTick": {
            "alignWithLabel": true
          },

          "nameTextStyle": {
            "color": "#82b0ec"
          },

          "axisLine": {
            show: false,
            "lineStyle": {
              "color": "#82b0ec"
            }
          },
          "splitLine": {
            show: true,
            "lineStyle": {
              "color": "#0834a8"
            }
          },
          "axisLabel": {
            show: false,
            "textStyle": {
              "color": "#fff"
            },
            margin: 30
          }
        }],
        "yAxis": [{
          show: true,
          "type": "value",
          axisLabel: {
            formatter: function (params) {
              // do some thing
              if (params != 0) {
                return params + '分'
              }
            },
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },

          "splitLine": {
            "lineStyle": {
              "color": "#0834a8"
            }
          },
          "axisTick": {
            show: false
          },

          "axisLine": {
            "show": false
          }
        }],
        "series": [{
          "name": "",
          type: 'pictorialBar',
          symbolSize: [40, 10],
          symbolOffset: [0, -6],
          symbolPosition: 'end',
          z: 12,
          // "barWidth": "0",
          "label": {
            "normal": {
              "show": true,
              "position": "top",
              // "formatter": "{c}%"
              fontSize: 25,
              fontWeight: 'bold',
              color: '#fff'
            }
          },
          "itemStyle": {
            "color": function (params) {
              return barTopColor[params.dataIndex];
            }
          },
          data: yData
        },
          {
            name: '',
            type: 'pictorialBar',
            symbolSize: [40, 10],
            symbolOffset: [0, 7],
            // "barWidth": "20",
            z: 12,
            "itemStyle": {
              "color": function (params) {
                return barBottomColor[params.dataIndex];
              }
            },
            "data": yData
          },

          {
            type: 'bar',
            //silent: true,
            "barWidth": "40",
            barGap: '10%', // Make series be overlap
            barCateGoryGap: '10%',
            itemStyle: {
              normal: {
                color: function (params) {
                  return new that.$echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [{
                        offset: 1,
                        color: barTopColor[params.dataIndex]
                      },
                        {
                          offset: 0,
                          color: barBottomColor[params.dataIndex]
                        }
                      ]
                  );
                },
                opacity: 1
              },
            },
            data: yData
          }
        ]
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.zzt2 {
  background: url("../assets/dipan.png") left bottom no-repeat;
  width: 618px;
  height: 500px;
  position: relative;
  margin-top: 0px;
  margin-left: 40px;

  .zzt {
    position: absolute;
    top: -120px;
    left: -110px;
    width: 710px;
    height: 500px;

  }
}

</style>
